import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { prestamoService } from '../services/api';
import '../styles/Clientes.css';
import { usePermisosGuard } from '../hooks/usePermisosGuard';

const PrestamosActivos = () => {
  usePermisosGuard('prestamos', 'ver');
  const [prestamos, setPrestamos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { codigo } = useParams();

  // Función para construir rutas con el código del tenant
  const getRoute = (path) => {
    return codigo ? `/${codigo}${path}` : path;
  };

  useEffect(() => {
    loadPrestamos();
  }, []);

  const loadPrestamos = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await prestamoService.getPrestamos({ estado: 'activo', per_page: 100 });
      setPrestamos(response.data.prestamos || []);
    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || 'Error al cargar los préstamos');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('es-DO');
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Préstamos Activos</h1>
        <button
          className="btn"
          onClick={() => navigate(getRoute('/dashboard'))}
          style={{background: '#666', color: '#fff'}}
        >
          ← Volver al Dashboard
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}

      <div className="card">
        <div className="card-title" style={{background: '#27ae60'}}>
          Préstamos amortizados
        </div>

        <p style={{padding: '1rem'}}>
          Mostrando registros del 1 al {prestamos.length} de un total de {prestamos.length} registros
        </p>

        {prestamos.length === 0 ? (
          <p style={{padding: '1rem', textAlign: 'center', color: '#666'}}>
            Ningún dato disponible en esta tabla
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Monto</th>
                  <th>Capital</th>
                  <th>A saldar</th>
                  <th>Cuota</th>
                  <th>Tasa</th>
                  <th>Modalidad</th>
                  <th>Dirección</th>
                  <th>Negocio</th>
                  <th>Fecha</th>
                  <th>Efectividad</th>
                </tr>
              </thead>
              <tbody>
                {prestamos.map((prestamo) => {
                  const saldo = prestamo.total - ((prestamo.total / prestamo.cuotas) * prestamo.cuotas_pagadas);
                  const cuota = prestamo.total / prestamo.cuotas;
                  return (
                    <tr key={prestamo.id}>
                      <td>{prestamo.id}</td>
                      <td>{prestamo.cliente?.nombres} {prestamo.cliente?.apellidos}</td>
                      <td>{formatMoney(prestamo.monto_prestado)}</td>
                      <td>{formatMoney(prestamo.capital)}</td>
                      <td>{formatMoney(saldo)}</td>
                      <td>{formatMoney(cuota)}</td>
                      <td>{prestamo.tasa}%</td>
                      <td>{prestamo.modalidad}</td>
                      <td>{prestamo.cliente?.direccion || 'N/A'}</td>
                      <td>{prestamo.cliente?.negocio || 'N/A'}</td>
                      <td>{formatDate(prestamo.fecha_inicio)}</td>
                      <td>{formatDate(prestamo.fecha_efectividad)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrestamosActivos;
